/** Notification endpoint calls — list, mark read (single or all), unread count. */
import type { Notification, PaginatedResponse } from '@olimhub/shared'
import { apiClient } from '../client'

export const notificationsApi = {
  getAll: (cursor?: string) =>
    apiClient
      .get<PaginatedResponse<Notification>>('/notifications', { params: { cursor } })
      .then((r) => r.data),

  markOneRead: (id: string) =>
    apiClient.put(`/notifications/${id}/read`).then((r) => r.data),

  markAllRead: () =>
    apiClient.post('/notifications/read-all').then((r) => r.data),

  getUnreadCount: () =>
    apiClient.get<{ count: number }>('/notifications/unread-count').then((r) => r.data.count),
}
